import React, { memo, useState } from 'react';
import { Checkbox, CountrySelect } from '@xbcb/form-item-components';
import { NamePath } from '@xbcb/ui-types';
import { Form, Row } from 'antd';

export interface SteelMeltAndPourCountryDetailProps {
  localNamePath: NamePath;
  fullNamePath: NamePath;
}

export const steelCountryOfMeltAndPourLabel = 'Country of Melt and Pour';
export const derivativeSteelProductOnlyLabel = 'Only Derivative Steel Articles';

export enum Section232SteelRequirementsFields {
  STEEL_COUNTRY_OF_MELT_AND_POUR = 'steelCountryOfMeltAndPour',
  // Regulation was changed from Mexico only to all countries.
  DERIVATIVE_STEEL_PRODUCT_ONLY = 'derivativeSteelProductOfMexicoOnly',
}

export const steelRequirementsFieldPrefix = 'steelRequirements';

const doesNotContainSteelField = 'doesNotContainSteel';
export const doesNotContainSteelLabel = 'Does not contain steel';

export const SteelMeltAndPourCountryDetail: React.FC<
  SteelMeltAndPourCountryDetailProps
> = ({ localNamePath, fullNamePath }) => {
  const fieldLocalNamePath = (field: Section232SteelRequirementsFields) => {
    return [...localNamePath, steelRequirementsFieldPrefix, field];
  };

  const fieldFullNamePath = (fieldName: Section232SteelRequirementsFields) => {
    return [...fullNamePath, steelRequirementsFieldPrefix, fieldName];
  };

  const form = Form.useFormInstance();

  const [doesNotContainSteel, setDoesNotContainSteel] = useState(() =>
    Boolean(form.getFieldValue([...fullNamePath, doesNotContainSteelField])),
  );

  const derivativeSteelProductOnly = Form.useWatch(
    fieldFullNamePath(
      Section232SteelRequirementsFields.DERIVATIVE_STEEL_PRODUCT_ONLY,
    ),
  );

  return (
    <>
      <Row>
        {!doesNotContainSteel && (
          <Checkbox
            localNamePath={fieldLocalNamePath(
              Section232SteelRequirementsFields.DERIVATIVE_STEEL_PRODUCT_ONLY,
            )}
            fullNamePath={fieldFullNamePath(
              Section232SteelRequirementsFields.DERIVATIVE_STEEL_PRODUCT_ONLY,
            )}
            form={form}
            text={derivativeSteelProductOnlyLabel}
          />
        )}
        <Checkbox
          localNamePath={[...localNamePath, doesNotContainSteelField]}
          fullNamePath={[...fullNamePath, doesNotContainSteelField]}
          form={form}
          text={doesNotContainSteelLabel}
          onChange={(event) => {
            setDoesNotContainSteel(event.target.checked);
            form.setFields([
              {
                name: [...fullNamePath, doesNotContainSteelField],
                value: event.target.checked,
              },
              {
                name: [...fullNamePath, steelRequirementsFieldPrefix],
                value: undefined,
              },
            ]);
          }}
        />
      </Row>
      {!doesNotContainSteel && (
        <CountrySelect
          label={steelCountryOfMeltAndPourLabel}
          localNamePath={fieldLocalNamePath(
            Section232SteelRequirementsFields.STEEL_COUNTRY_OF_MELT_AND_POUR,
          )}
          required={!derivativeSteelProductOnly}
        />
      )}
    </>
  );
};

export default memo(SteelMeltAndPourCountryDetail);
